"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNethpHref = exports.fillUrl = exports.getWebViewUrl = exports.getRealUrlFromWebViewUrl = exports.goPageBack = exports.reactHistoryFunc = void 0;
var getRelSeoUrl_1 = require("../seo/getRelSeoUrl");
var getGlobalWindow_1 = require("./getGlobalWindow");
var getUrlParam_1 = require("./getUrlParam");
var miniprogramQuery_1 = require("./miniprogramQuery");
var searchParam_1 = require("./searchParam");
var ua_1 = require("./ua");
var locationTemp = {
    val: undefined,
    cfg: {
        scene: ["seo", "nethpMin"],
        params: ["tenantId"],
    },
};
function reactHistoryFunc(historyFunc, params) {
    if (!historyFunc) {
        return false;
    }
    if (!params) {
        return false;
    }
    if (typeof params === "string") {
        historyFunc === null || historyFunc === void 0 ? void 0 : historyFunc(params);
    }
    else {
    }
}
exports.reactHistoryFunc = reactHistoryFunc;
function goPageBack() {
    var _a, _b, _c, _d;
    var wd = (0, getGlobalWindow_1.getWindow)();
    if (((_a = wd.history) === null || _a === void 0 ? void 0 : _a.length) > 1 && ((_b = wd.history) === null || _b === void 0 ? void 0 : _b.go)) {
        requestAnimationFrame(function () {
            var _a, _b;
            (_b = (_a = wd.history) === null || _a === void 0 ? void 0 : _a.go) === null || _b === void 0 ? void 0 : _b.call(_a, -1);
        });
        return 0;
    }
    if ((0, ua_1.isJDApp)()) {
        // 京东内
        requestAnimationFrame(function () {
            wd.location.href = "closeJDApp://webview?refresh=true";
        });
        return 1;
    }
    if ((0, ua_1.isJDHApp)()) {
        // 京东健康app内
        requestAnimationFrame(function () {
            wd.location.href = "closeJDHApp://webview?refresh=true";
        });
        return 1;
    }
    if ((0, ua_1.isMiniprogramOnly)() && ((_d = (_c = wd === null || wd === void 0 ? void 0 : wd.wx) === null || _c === void 0 ? void 0 : _c.miniProgram) === null || _d === void 0 ? void 0 : _d.navigateBack)) {
        requestAnimationFrame(function () {
            var _a, _b;
            (_b = (_a = wd === null || wd === void 0 ? void 0 : wd.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.navigateBack();
        });
        return 2;
    }
    requestAnimationFrame(function () {
        var _a, _b;
        (_b = (_a = wd.history) === null || _a === void 0 ? void 0 : _a.back) === null || _b === void 0 ? void 0 : _b.call(_a);
    });
    return 0;
}
exports.goPageBack = goPageBack;
function getRealUrlFromWebViewUrl(wurl) {
    if (!wurl) {
        return wurl;
    }
    if (!wurl.startsWith("openApp.")) {
        return wurl;
    }
    try {
        var s1 = wurl.split("params=");
        var s2 = s1 === null || s1 === void 0 ? void 0 : s1[1];
        var s3 = s2 === null || s2 === void 0 ? void 0 : s2.split("&");
        var s4 = s3 === null || s3 === void 0 ? void 0 : s3[0];
        var s5 = s4 === null || s4 === void 0 ? void 0 : s4.lastIndexOf("}");
        var str = s4;
        if (s5 !== undefined && s5 !== -1) {
            var s6 = s4.slice(0, s5 + 1);
            str = s6;
        }
        var params = str ? JSON.parse(str) : {};
        var url = fillUrl(params === null || params === void 0 ? void 0 : params.url);
        return url ? decodeURIComponent(url) : wurl;
    }
    catch (e) {
        console.log("error", e);
    }
    return wurl;
}
exports.getRealUrlFromWebViewUrl = getRealUrlFromWebViewUrl;
function getWebViewUrl(url) {
    if (!url) {
        return url;
    }
    var fUrl = fillUrl(url) || "";
    if ((0, ua_1.isJDApp)()) {
        var jumpParams = JSON.stringify({
            category: "jump",
            des: "m",
            action: "to",
            url: encodeURIComponent(fUrl),
        });
        // 京东内
        var wUrl = "openApp.jdMobile://virtual?params=".concat(jumpParams);
        return wUrl;
    }
    if ((0, ua_1.isJDHApp)()) {
        var jumpParams = JSON.stringify({
            category: "jump",
            des: "m",
            // action: "to",
            url: encodeURIComponent(fUrl),
        });
        // 京东健康app内
        var wUrl = "openApp.jdHealth://virtual?params=".concat(jumpParams);
        return wUrl;
    }
    return fUrl;
}
exports.getWebViewUrl = getWebViewUrl;
function fillUrl(url, baseUrl, basename) {
    if (!url) {
        return url;
    }
    var wd = (0, getGlobalWindow_1.getWindow)();
    if (url.startsWith("//")) {
        return "".concat(wd.location.protocol).concat(url);
    }
    if (url.startsWith("/") || url.startsWith("?") || url.startsWith("#")) {
        return "".concat(baseUrl ? fillUrl(baseUrl) : wd.location.origin).concat(basename || "").concat(url);
    }
    return url;
}
exports.fillUrl = fillUrl;
function getRuleUrl(_a) {
    var paramsArr = _a.paramsArr, sceneArr = _a.sceneArr, realLocation = _a.realLocation, strUrl = _a.strUrl;
    try {
        if (!strUrl) {
            return strUrl;
        }
        var cfgIsNone = !(sceneArr === null || sceneArr === void 0 ? void 0 : sceneArr.length) && !(paramsArr === null || paramsArr === void 0 ? void 0 : paramsArr.length);
        if (cfgIsNone) {
            return strUrl;
        }
        var needInsertParams_1 = paramsArr || [];
        if (sceneArr === null || sceneArr === void 0 ? void 0 : sceneArr.includes("nethpMin")) {
            miniprogramQuery_1.miniprogramparamsArrList.forEach(function (k) {
                needInsertParams_1.push(k);
            });
        }
        if (needInsertParams_1.length) {
            var hrefarams_1 = (0, getUrlParam_1.getUrlParam)(realLocation.href);
            var hrefParamsKeys = Object.keys(hrefarams_1);
            if (hrefParamsKeys.length) {
                var needInsertParamsObj = needInsertParams_1.reduce(function (v, k) {
                    // @ts-ignore
                    var val = hrefarams_1 === null || hrefarams_1 === void 0 ? void 0 : hrefarams_1[k];
                    if (val) {
                        // @ts-ignore
                        v[k] = val;
                    }
                    return v;
                }, {});
                if (Object.keys(needInsertParamsObj).length) {
                    var urlParams = (0, getUrlParam_1.getUrlParam)(strUrl);
                    var preUrl = strUrl.split("?")[0];
                    Object.assign(urlParams, needInsertParamsObj);
                    strUrl = "".concat(preUrl, "?").concat((0, searchParam_1.searchParam)(urlParams));
                }
            }
        }
    }
    catch (e) {
        console.log("error", e, strUrl, paramsArr, sceneArr);
    }
    return strUrl;
}
function getNethpHref(onceCfg) {
    var wd = (0, getGlobalWindow_1.getWindow)();
    if (locationTemp.val) {
        return locationTemp.val || wd.nethpHrefLocation;
    }
    var realLocation = wd.location;
    var cfg = onceCfg || locationTemp.cfg;
    // @ts-ignore
    locationTemp.val = new Proxy({}, {
        get: function (target, propKey) {
            var _this = this;
            try {
                var defaultFunc = function () {
                    // @ts-ignore
                    return realLocation[propKey];
                };
                var sceneArr_1 = cfg === null || cfg === void 0 ? void 0 : cfg.scene;
                var paramsArr_1 = cfg === null || cfg === void 0 ? void 0 : cfg.params;
                var reactHistoryCfg_1 = cfg === null || cfg === void 0 ? void 0 : cfg.reactHistoryCfg;
                if (propKey === "replace" ||
                    propKey === "webviewRedirect" ||
                    propKey === "getRealHref") {
                    var func = function (url, isWebview) { return __awaiter(_this, void 0, void 0, function () {
                        var strUrl, aimUrl, defaultUrl_1;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    strUrl = url === null || url === void 0 ? void 0 : url.toString();
                                    strUrl = fillUrl(strUrl);
                                    strUrl = getRealUrlFromWebViewUrl(strUrl);
                                    strUrl = getRuleUrl({
                                        sceneArr: sceneArr_1,
                                        paramsArr: paramsArr_1,
                                        strUrl: strUrl,
                                        realLocation: realLocation,
                                    });
                                    if (!(sceneArr_1 === null || sceneArr_1 === void 0 ? void 0 : sceneArr_1.includes("seo"))) return [3 /*break*/, 2];
                                    return [4 /*yield*/, (0, getRelSeoUrl_1.getRelSeoUrl)(strUrl)];
                                case 1:
                                    aimUrl = _b.sent();
                                    if (aimUrl) {
                                        strUrl = aimUrl;
                                    }
                                    else {
                                        console.log("error", propKey, strUrl, aimUrl);
                                    }
                                    _b.label = 2;
                                case 2:
                                    if (propKey === "getRealHref" && !isWebview) {
                                        return [2 /*return*/, strUrl];
                                    }
                                    if (propKey === "webviewRedirect" ||
                                        (propKey === "getRealHref" && isWebview)) {
                                        strUrl = getWebViewUrl(strUrl);
                                        if (strUrl) {
                                            if (propKey === "getRealHref") {
                                                return [2 /*return*/, strUrl];
                                            }
                                            requestAnimationFrame(function () {
                                                if (strUrl) {
                                                    realLocation.href = strUrl;
                                                }
                                                else {
                                                    console.log("error", propKey, strUrl);
                                                }
                                            });
                                            return [2 /*return*/, strUrl];
                                        }
                                        else {
                                            console.log("error", propKey, strUrl);
                                            defaultUrl_1 = url === null || url === void 0 ? void 0 : url.toString();
                                            if (defaultUrl_1) {
                                                if (propKey === "getRealHref") {
                                                    return [2 /*return*/, defaultUrl_1];
                                                }
                                                requestAnimationFrame(function () {
                                                    realLocation.href = defaultUrl_1;
                                                });
                                                return [2 /*return*/, defaultUrl_1];
                                            }
                                            else {
                                                console.log("error", propKey, defaultUrl_1);
                                            }
                                            return [2 /*return*/, defaultUrl_1];
                                        }
                                    }
                                    if (propKey === "replace") {
                                        requestAnimationFrame(function () {
                                            var _a;
                                            // @ts-ignore
                                            (_a = realLocation[propKey]) === null || _a === void 0 ? void 0 : _a.call(realLocation, strUrl || url);
                                        });
                                    }
                                    else {
                                        // @ts-ignore
                                        (_a = realLocation[propKey]) === null || _a === void 0 ? void 0 : _a.call(realLocation, strUrl || url);
                                    }
                                    return [2 /*return*/, strUrl || url];
                            }
                        });
                    }); };
                    return func.bind(realLocation);
                }
                else if (propKey === "getSearchParams") {
                    var func = function (url) {
                        var strUrl = (url === null || url === void 0 ? void 0 : url.toString()) || realLocation.href;
                        strUrl = fillUrl(strUrl);
                        strUrl = getRealUrlFromWebViewUrl(strUrl);
                        return (0, getUrlParam_1.getUrlParam)(strUrl);
                    };
                    return func.bind(realLocation);
                }
                else if (propKey === "getFillHref") {
                    var func = function (url, params) {
                        var _a;
                        var strUrl = (url === null || url === void 0 ? void 0 : url.toString()) || realLocation.href;
                        var hrefarams = (0, getUrlParam_1.getUrlParam)(strUrl);
                        Object.assign(hrefarams, params);
                        var preUrl = (_a = strUrl.split("?")) === null || _a === void 0 ? void 0 : _a[0];
                        strUrl = "".concat(preUrl, "?").concat((0, searchParam_1.searchParam)(hrefarams));
                        return strUrl;
                    };
                    return func.bind(realLocation);
                }
                else if (propKey === "goPageBack") {
                    return goPageBack.bind(realLocation);
                }
                else if (propKey === "reactPush" || propKey === "reactReplace") {
                    var func = function (params) {
                        if (!params) {
                            return;
                        }
                        var strUrl;
                        if (typeof params === "string") {
                            strUrl = params;
                        }
                        else {
                            var pathname = params.pathname, search = params.search, hash = params.hash;
                            if (pathname && !(pathname === null || pathname === void 0 ? void 0 : pathname.startsWith("/"))) {
                                pathname = "/".concat(pathname);
                            }
                            if (search && !(search === null || search === void 0 ? void 0 : search.startsWith("?"))) {
                                search = "?".concat(search);
                            }
                            if (hash && !(hash === null || hash === void 0 ? void 0 : hash.startsWith("#"))) {
                                hash = "#".concat(hash);
                            }
                            strUrl = "".concat(pathname).concat(search).concat(hash) || "/";
                        }
                        strUrl = fillUrl(strUrl, reactHistoryCfg_1 === null || reactHistoryCfg_1 === void 0 ? void 0 : reactHistoryCfg_1.baseUrl, reactHistoryCfg_1 === null || reactHistoryCfg_1 === void 0 ? void 0 : reactHistoryCfg_1.basename);
                        strUrl = getRuleUrl({
                            sceneArr: sceneArr_1,
                            paramsArr: paramsArr_1,
                            strUrl: strUrl,
                            realLocation: realLocation,
                        });
                        var history = reactHistoryCfg_1 === null || reactHistoryCfg_1 === void 0 ? void 0 : reactHistoryCfg_1.history;
                        var _func;
                        if (propKey === "reactPush") {
                            _func = history === null || history === void 0 ? void 0 : history.push;
                        }
                        else if (propKey === "reactReplace") {
                            _func = history === null || history === void 0 ? void 0 : history.replace;
                        }
                        var urlPre = "".concat((reactHistoryCfg_1 === null || reactHistoryCfg_1 === void 0 ? void 0 : reactHistoryCfg_1.baseUrl) || "").concat((reactHistoryCfg_1 === null || reactHistoryCfg_1 === void 0 ? void 0 : reactHistoryCfg_1.basename) || "");
                        if (urlPre && _func) {
                            var strUrlArr = strUrl === null || strUrl === void 0 ? void 0 : strUrl.split(urlPre);
                            var reactUrl = (strUrlArr === null || strUrlArr === void 0 ? void 0 : strUrlArr[1]) || "/";
                            _func(reactUrl);
                        }
                        else {
                            if (propKey === "reactPush") {
                                if (strUrl) {
                                    getNethpHref(onceCfg).href = strUrl;
                                }
                                else {
                                    console.log("error", propKey, strUrl);
                                }
                            }
                            else if (propKey === "reactReplace") {
                                if (strUrl) {
                                    getNethpHref(onceCfg).replace(strUrl);
                                }
                                else {
                                    console.log("error", propKey, strUrl);
                                }
                            }
                        }
                    };
                    return func.bind(realLocation);
                }
                return defaultFunc();
            }
            catch (e) {
                console.log("error", e, propKey);
            }
            // @ts-ignore
            return realLocation[propKey];
        },
        set: function (target, propKey, value) {
            var _this = this;
            try {
                var setFunc_1 = function (newVal) {
                    if (newVal === void 0) { newVal = value; }
                    if (propKey === "href") {
                        requestAnimationFrame(function () {
                            realLocation[propKey] = newVal;
                        });
                        return true;
                    }
                    // @ts-ignore
                    realLocation[propKey] = newVal;
                    return true;
                };
                var sceneArr = cfg === null || cfg === void 0 ? void 0 : cfg.scene;
                var paramsArr = cfg === null || cfg === void 0 ? void 0 : cfg.params;
                if (propKey === "href") {
                    var url_1 = value;
                    var strUrl_1 = url_1.toString();
                    strUrl_1 = fillUrl(strUrl_1);
                    strUrl_1 = getRealUrlFromWebViewUrl(strUrl_1);
                    strUrl_1 = getRuleUrl({
                        sceneArr: sceneArr,
                        paramsArr: paramsArr,
                        strUrl: strUrl_1,
                        realLocation: realLocation,
                    });
                    if (sceneArr === null || sceneArr === void 0 ? void 0 : sceneArr.includes("seo")) {
                        var func = function () { return __awaiter(_this, void 0, void 0, function () {
                            var aimUrl;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, (0, getRelSeoUrl_1.getRelSeoUrl)(strUrl_1)];
                                    case 1:
                                        aimUrl = _a.sent();
                                        if (aimUrl) {
                                            strUrl_1 = aimUrl;
                                        }
                                        else {
                                            console.log("error", propKey, strUrl_1, aimUrl);
                                        }
                                        return [2 /*return*/, setFunc_1(strUrl_1 || url_1)];
                                }
                            });
                        }); };
                        func();
                        return true;
                    }
                    return setFunc_1(strUrl_1 || url_1);
                }
                return setFunc_1();
            }
            catch (e) {
                console.log("error", e, propKey, value);
            }
            // @ts-ignore
            realLocation[propKey] = value;
            return true;
        },
    });
    wd.nethpHrefLocation = locationTemp.val;
    // @ts-ignore
    return locationTemp.val;
}
exports.getNethpHref = getNethpHref;
getNethpHref.setConfig = function (cfg) {
    locationTemp.cfg = __assign(__assign({}, locationTemp.cfg), cfg);
};
getNethpHref.getConfig = function () {
    return locationTemp.cfg;
};
